module.exports = __webpack_public_path__ + "img/tool_premium.953171dc.png";